import React from "react";
import LoadingCircle from "../../core/view/LoadingCircle";
import * as styles from "./styles/StudentRegistration.css";

type RegistrationButtonProps = {
	onClick: () => void;
	buttonText: string;
	className?: string;
	isSavingRegistration?: boolean;
};

const getKeyHandler = (f: () => void) => {
	return (evt: React.KeyboardEvent<HTMLDivElement>) => {
		if (evt.which === 13) {
			f();
		}
	};
};

// TODO: Make this an actual button, not a div
const RegistrationButton = ({
	onClick,
	buttonText,
	className = styles.button,
	isSavingRegistration = false,
}: RegistrationButtonProps) => {
	return (
		<div
			className={className}
			onClick={onClick}
			onKeyPress={getKeyHandler(onClick)}
			tabIndex={0}
		>
			<div className={styles.buttonText}>
				{buttonText}
				{isSavingRegistration && (
					<div className={styles.buttonLoader}>
						<LoadingCircle colorType="white" noCenter={true} />
					</div>
				)}
			</div>
		</div>
	);
};

export default RegistrationButton;
